import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext, useEffect, useRef } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import devWarning from '../_utils/devwarning';
import Marks from './marks';
import Steps from './steps';
import Track from './track';
import SliderTooltip from './sliderTooltip';
import { useMergedState } from '../_utils/hooks';
import { getHandleCenterposition, ensureValueInRange, ensureValuePrecision } from './utils';
// remove this line and code Slider component here
var InteranalSlider = function InteranalSlider(props, ref) {
  var _classNames;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var sliderProps = getCompProps('Slider', userDefaultProps, props);
  var className = sliderProps.className,
    style = sliderProps.style,
    customPrefixcls = sliderProps.prefixCls,
    defaultValue = sliderProps.defaultValue,
    disabled = sliderProps.disabled,
    dots = sliderProps.dots,
    marks = sliderProps.marks,
    min = sliderProps.min,
    max = sliderProps.max,
    vertical = sliderProps.vertical,
    reverse = sliderProps.reverse,
    step = sliderProps.step,
    tipFormatter = sliderProps.tipFormatter,
    tooltipVisible = sliderProps.tooltipVisible,
    tooltipPlacement = sliderProps.tooltipPlacement,
    propsValue = sliderProps.value,
    getPopupContainer = sliderProps.getPopupContainer,
    onAfterChange = sliderProps.onAfterChange,
    onChange = sliderProps.onChange,
    onBlur = sliderProps.onBlur,
    others = __rest(sliderProps, ["className", "style", "prefixCls", "defaultValue", "disabled", "dots", "marks", "min", "max", "vertical", "reverse", "step", "tipFormatter", "tooltipVisible", "tooltipPlacement", "value", "getPopupContainer", "onAfterChange", "onChange", "onBlur"]);
  devWarning(className && className.indexOf('shit') > -1, 'slider', "slider className can't include '".concat(className, "'"));
  var sliderPrefixCls = getPrefixCls(prefixCls, 'slider', customPrefixcls);
  // ref
  var thisSliderRef = useRef();
  var sliderRef = ref || thisSliderRef;
  var handleRef = useRef();
  var sliderClasses = classNames(sliderPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(sliderPrefixCls, "-vertical"), vertical), _defineProperty(_classNames, "".concat(sliderPrefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(sliderPrefixCls, "-reverse"), reverse), _classNames));
  var _useMergedState = useMergedState(0, {
      defaultValue: defaultValue,
      value: propsValue
    }),
    _useMergedState2 = _slicedToArray(_useMergedState, 2),
    value = _useMergedState2[0],
    setValue = _useMergedState2[1];
  var isDragging = useRef(false);
  var valueRef = useRef(useMergedState(0, {
    defaultValue: defaultValue,
    value: propsValue
  }));
  var mouseOffset;
  var addDocumentMouseEvents = function addDocumentMouseEvents() {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };
  var removeDocumentEvents = function removeDocumentEvents() {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };
  var noop = function noop() {
    return undefined;
  };
  // 获取开始位置尺寸
  var getSliderStart = function getSliderStart() {
    var rect = sliderRef.current.getBoundingClientRect();
    if (vertical) {
      return reverse ? rect.bottom : rect.top;
    }
    return window.pageXOffset + (reverse ? rect.right : rect.left);
  };
  // 获取整个滑块的长度
  var getSliderLength = function getSliderLength() {
    var slider = sliderRef.current;
    if (!slider) {
      return 0;
    }
    var coords = slider.getBoundingClientRect();
    return vertical ? coords.height : coords.width;
  };
  // 将鼠标点击位置距开始位置的偏移量转化为value
  var calcValue = function calcValue(offset) {
    var ratio = Math.abs(Math.max(offset, 0) / getSliderLength());
    var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
    return value;
  };
  // 对值进行转化 1. 在[min, max]区间 2. 当设置了step或者marks时找到距离最近的点
  var trimAlignValue = function trimAlignValue(v) {
    var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (v === null) {
      return null;
    }
    var mergedProps = _extends(_extends({}, sliderProps), nextProps);
    var val = ensureValueInRange(v, mergedProps);
    return ensureValuePrecision(val, mergedProps);
  };
  // 将鼠标点击的位置转化value
  var calcValueByPos = function calcValueByPos(position) {
    var sign = reverse ? -1 : +1;
    var pixelOffset = sign * (position - getSliderStart());
    var nextValue = trimAlignValue(calcValue(pixelOffset));
    return nextValue;
  };
  var onEnd = function onEnd() {
    removeDocumentEvents();
    if (isDragging.current) {
      onAfterChange && onAfterChange(valueRef.current);
    }
    isDragging.current = false;
  };
  var handleTouchStart = function handleTouchStart() {
    // console.log('object :>> ', 'object', addDocumentMouseEvents)
  };
  var handleMouseDown = function handleMouseDown(e) {
    // 移除document的鼠标事件
    removeDocumentEvents();
    // 获取当前鼠标的坐标位置
    var position = vertical ? e.clientY : e.pageX;
    // 判断当前点击的区域是否是拖拽点还是bar条
    var isHandlePoint = handleRef.current === e.target;
    if (!isHandlePoint) {
      mouseOffset = 0;
    } else {
      var handlePosition = getHandleCenterposition(vertical, e.target);
      mouseOffset = position - handlePosition;
      position = handlePosition;
    }
    // 设置状态值
    isDragging.current = true;
    var newV = calcValueByPos(position);
    if (newV !== value) {
      setValue(newV);
      valueRef.current = newV;
    }
    onChange && onChange(newV);
    // 监听document的鼠标事件
    addDocumentMouseEvents();
  };
  var handleMouseUp = function handleMouseUp() {
    onEnd();
  };
  var handleKeyDown = function handleKeyDown() {
    // console.log('object :>> ', 'object')
  };
  var handleFocus = function handleFocus() {
    // console.log('object :>> ', 'object')
  };
  var handleBlur = function handleBlur(e) {
    onEnd();
    onBlur && onBlur(e);
  };
  var handleMouseMove = function handleMouseMove(e) {
    if (!sliderRef.current) {
      removeDocumentEvents();
      if (isDragging.current) {
        onAfterChange(value);
      }
      isDragging.current = false;
      return;
    }
    var position = vertical ? e.clientY : e.pageX;
    var newV = calcValueByPos(position - mouseOffset);
    if (newV !== value) {
      setValue(newV);
      valueRef.current = newV;
    }
    onChange && onChange(newV);
  };
  useEffect(function () {
    return function () {
      removeDocumentEvents();
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: sliderRef,
    className: sliderClasses
  }, others, {
    style: style,
    onTouchStart: disabled ? noop : handleTouchStart,
    onMouseDown: disabled ? noop : handleMouseDown,
    // onMouseUp={disabled ? noop : handleMouseUp}
    onKeyDown: disabled ? noop : handleKeyDown,
    onFocus: disabled ? noop : handleFocus,
    onBlur: disabled ? noop : handleBlur
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(sliderPrefixCls, "-rail")
  }), /*#__PURE__*/React.createElement(Track, {
    prefixCls: sliderPrefixCls,
    vertical: vertical,
    reverse: reverse,
    min: min,
    max: max,
    bound: value
  }), /*#__PURE__*/React.createElement(Steps, {
    marks: marks,
    prefixCls: sliderPrefixCls,
    vertical: vertical,
    min: min,
    max: max,
    dots: dots,
    step: step,
    reverse: reverse,
    bound: value
  }), /*#__PURE__*/React.createElement(SliderTooltip, {
    ref: handleRef,
    placement: tooltipPlacement,
    tip: tipFormatter === null || tipFormatter === void 0 ? void 0 : tipFormatter(value),
    visible: disabled ? false : tooltipVisible,
    prefixCls: sliderPrefixCls,
    vertical: vertical,
    reverse: reverse,
    min: min,
    max: max,
    bound: value,
    getPopupContainer: getPopupContainer
  }), /*#__PURE__*/React.createElement(Marks, {
    marks: marks,
    prefixCls: sliderPrefixCls,
    vertical: vertical,
    reverse: reverse,
    min: min,
    max: max,
    bound: value,
    onClickLabel: function onClickLabel() {
      // console.log('hello world!')
    }
  }));
};
var Slider = /*#__PURE__*/React.forwardRef(InteranalSlider);
Slider.displayName = 'Slider';
export default Slider;